// src/components/UI/InputWithIcon.jsx
import React from 'react';
import {
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement, 
} from '@chakra-ui/react';

const InputWithIcon = ({ icon, value, ...rest }) => {
  const hasValue = value && value.length > 0;

  return (
    <InputGroup>
      <Flex
        w="100%"
        align="center"
        bg="surface"
        border="1px solid"
        borderColor="gray.700"
        borderRadius="lg"
        transition="border-color 0.3s ease"
        _focusWithin={{
          borderColor: 'secondary',
        }}
        overflow="hidden"
      >
        <Input
          h="3rem"
          border="none"
          outline="none"
          bg="transparent"
          color="white"
          fontSize="0.9rem"
          pr="3rem" 
          _focus={{
            boxShadow: 'none',
          }}
          _placeholder={{ color: 'gray.400' }}
          value={value}
          {...rest}
        />
        <InputRightElement pointerEvents="none" h="100%">
          <Icon as={icon} color={hasValue ? 'white' : 'gray.400'} />
        </InputRightElement>
      </Flex>
    </InputGroup>
  );
};

export default InputWithIcon;